<!-- <div  *ngIf="editeurs">
    <div class="chart-wrapper">
        <canvas baseChart 
          [data]="doughnutChartData"
          [labels]="doughnutChartLabels"
          [chartType]="doughnutChartType" 
          [legend]="true"
          (click)="chartClicked($event.label)"
          height="auto"
          [legend]="true"
          [options]="options"
          width="140">
      </canvas>
    </div>
</div> -->
<table class="table table-bordered">
  <thead>
    <tr>
      <th scope="col">{{ namep | translate }}</th>
      <th scope="col">{{ 'nbr' | translate }}</th>
      <th scope="col" *ngIf="namep != 'traducteurs' && namep != 'auteurs'">%</th>
    </tr>
  </thead>
  <tbody *ngIf="namep == 'traducteurs' || namep == 'auteurs'">
    <tr   *ngFor="let l of editeurs">
      <td>{{ l.name | selectbar : 'a' : translate.currentLang  }}</td>
      <td>{{ l.y }}</td>
    </tr>
    <tr>
      <th scope="row">{{ 'total' | translate }}</th>
      <th scope="row">{{ bdr }}</th>
    </tr>
  </tbody>
  <tbody *ngIf="namep != 'traducteurs' && namep != 'auteurs'">
    <tr   *ngFor="let l of editeurs">
      <td>{{ l.name  }}</td>
      <td>{{ l.y }}</td>
      <td>{{ l.y*100/bdr | number : '1.2-2'  }} %</td>
    </tr>
    <tr>
      <th scope="row">{{ 'total' | translate }}</th>
      <th scope="row">{{ bdr }}</th>
      <th>{{ bdr*100/bdr | number  }} %</th>
    </tr>
  </tbody>
</table>
<div [id]="name" style="height: 370px; width: 100%; direction: ltr; margin-left:auto;margin-right:auto;"></div>